import React from 'react';
import PdfHeaderComponent from './PdfHeaderComponent';
import { getProjectStatistics } from "../../../../apis/impact-report/report";
import useFetchData from "../../../../hooks/useFetchData";
import PdfHorizontalBarChart from "./charts/PdfHorizontalBarChart";
import Loader from "../../../../ui/Loader";
import { paginateHorizontalBarData, calculateChartDomain, generatePageTitle } from './utils/chartPagination';

const FundsPageComponent = ({ projectId, projectData }) => {
  // Fetch Funds data
  const { loading, response } = useFetchData(
    getProjectStatistics,
    [projectId, "BOUNTY_WISE_REWARDED_AMOUNT", "", ""],
    [projectId, "BOUNTY_WISE_REWARDED_AMOUNT", "", ""]
  );

  // Transform Funds data
  const fundsData = response?.bountyWiseRewardedAmount?.map(reward => ({
    name: reward?.title,
    value: reward?.rewardedAmountUSD,
    key: reward?._id
  }))?.sort((a, b) => b?.value - a?.value) || [];


  // Paginate Funds data
  const paginatedFundsData = paginateHorizontalBarData(fundsData, 27);
  const fundsDomainData = calculateChartDomain(fundsData);

  if (loading) {
    return (
      <div className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
        <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
        <div className='w-full h-[23.9375rem] flex pt-11 justify-center'>
          <Loader />
        </div>
      </div>
    );
  }

  if (paginatedFundsData.length === 0) {
    return (
      <div className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
        <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <h2 className="text-lg font-bold text-gray-900 mb-2">Funds</h2>
          <p className="text-xs text-gray-600 mb-3">Funding deployed per activity</p>
          <div className="bg-grayBgNormal p-4 rounded-lg border border-gray-200 text-center text-gray-500" style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="text-xs">No funds data available</div>
          </div>
        </div>
      </div>
    );
  }

  // Render each page of Funds data
  return (
    <>
      {paginatedFundsData.map((pageData, pageIndex) => {
        const pageNumber = pageIndex + 1;
        const totalPages = paginatedFundsData.length;
        const pageTitle = generatePageTitle("Funds", pageNumber, totalPages);
        return (
          <div key={`funds-page-${pageIndex}`} className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px', height: '100vh' }}>
            <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <h2 className="text-lg font-bold text-gray-900 mb-2">{pageTitle}</h2>
              <p className="text-xs text-gray-600 mb-3">Funds allocated per activity</p>
              
              <div className="bg-grayBgNormal p-4 rounded-lg " style={{ flex: 1, minHeight: '980px' }}>
                <PdfHorizontalBarChart
                  data={pageData}
                  xAxisLabel="Funds allocated (USD)"
                  yAxisLabel="Activities"
                  barSize={16}
                  showReferenceLine={true}
                  referenceLineValue={Math.max(...fundsDomainData.ticks) * 0.5}
                  domain={fundsDomainData.domain}
                  ticks={fundsDomainData.ticks}
                  showLegend={false}
                />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FundsPageComponent;
